export default class BaseShaderNode {
  constructor() { }
  getDefines() { return ''; }
  getFunctions() { return ''; }
  getMainBody() { return ''; }
}
